import { Component, ElementRef, HostListener, Input, Renderer2, ViewChild } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from 'src/app/pages/product-detail-updated/product-detail-updated.module';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import { MCommonListModalRequest, SharedPrefrences } from 'src/app/utils/utils.service';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginPopupComponent } from '../login-popup/login-popup.component';
import { Router } from '@angular/router';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';
import { WsLandingService } from 'src/app/ws/wsLanding/ws-landing.service';
import { MBrandListModal, MGetAllShopAllModuleDataResponse, MGetBrandResponse } from 'src/app/pages/product/product.module';
import { WsSubHeaderService } from 'src/app/ws/wsSubHeader/ws-sub-header.service';
import { ToastrService } from 'ngx-toastr';
import { MCheckoutRequest } from 'src/app/pages/checkout-new/checkout-new.module';
import { WsCheckoutService } from 'src/app/ws/wsCheckout/ws-checkout.service';
declare var $: any;

@Component({
  selector: 'app-header-bg',
  templateUrl: './header-bg.component.html',
  styleUrls: ['./header-bg.component.scss']
})
export class HeaderBgComponent {
  mAddUpdateCartModuleResponse: any = new MAddUpdateCartModuleResponse()
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule()
  totalAmount: any = 0;
  @ViewChild('content')
  content!: ElementRef;
  userId: any;
  mWishlistData: any = [];
  show: boolean = false;
  showNoData: boolean = false;
  showOldData: boolean = false;
  private storageKey = 'searchHistory';
  searchHistory: any = null;
  arrSearchHistory: any = [];
  text: any = ''
  customerData: any;
  productList: any = [];
  brandList: any = [];
  categoryList: any = [];
  skinTypeList: any = [];
  skinConcernsList: any = [];
  @Input() url: any;
  brandClickActive: boolean = false;
  alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest()
  @Input() mGetBrandResponse: MGetBrandResponse = new MGetBrandResponse()
  alphaSelected: boolean = false;
  alphaSelectedValue: any = '';
  brandImageList: any = [];
  @Input() customerMenuLists: any = []
  mGetAllShopAllModuleDataResponse: MGetAllShopAllModuleDataResponse = new MGetAllShopAllModuleDataResponse();
  categoryDetails: any;
  profileImage: any = 'assets/images/new-profile-icon.png'
  userData: any = null;
  lastScrollTop: any = 0;
  cartAmount: number = 499;
  mobileSearchShow: boolean = false;
  isMobile: boolean = false;
  wishlist: any = [];
  subTotalAmount: number = 0;
  totalItems: number = 0;
  mCheckoutRequest: MCheckoutRequest = new MCheckoutRequest();
  taxableAmount: any = 0;
  productIds: any = [];
  brandIds: any = [];
  categoryIds: any = [];
  taxableAmountCalculate: any = 0;
  ProductIds: any;
  BrandIds: any;
  CategoryIds: any;
  totalAmountWithoutDiscount: any = 0;
  showDiscountOnTotal: any;
  discount: any;
  discountApplied: any = 0;
  discountAmount: any = 0;
  discountList: any = [];
  boolOffer: boolean = false;
  mobileAddress: boolean = false;
  cartAddress: boolean = false;
  mobilePaymentClick: boolean = false;
  mobileOfferClick: boolean = false;
  discountCode: any;
  isShowOfferList: any;
  offers: boolean = false;
  discountId: any;
  viewOffers: boolean = false;
  shippingCharge: number = 0;
  totalAmountForShipping: number = 0;
  alreadyProcessedIds: Set<number> = new Set();
  @Input() alphabets: any = []
  type: any;
  wishlistData: any = [];

  constructor(private wssubheaderservice: WsSubHeaderService,
    private elem: ElementRef, private wsLandingService: WsLandingService,
    private wsUserProfileService: WsUserProfileService, private router: Router,
    private modalService: NgbModal, private wsShopAllService: WsShopallService,
    private _commonBehaviorChangeService: CommonBehaviorChangeService,private wsCheckoutService: WsCheckoutService,
    private renderer: Renderer2, private el: ElementRef, private toast: ToastrService) {
    this.mAddUpdateCartModuleResponse.data = [];
    this._commonBehaviorChangeService.currentAddCart.subscribe((add: any) => {
      if (add) {
        if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
          setTimeout(() => {
            this.getAllCartProducts();
          }, 500);
        }
      }
    })
    this._commonBehaviorChangeService.currentUpdateProfile.subscribe((add: any) => {
      if (add) {
        this.userData = JSON.parse("" + SharedPrefrences.getUserData());
        if (this.userData.profile_pic != null && this.userData.profile_pic != '') {
          this.profileImage = this.userData.profile_pic;
        }
      } else {
        this.userData = null;
      }
    })

    this._commonBehaviorChangeService.currentAddWishlist.subscribe((add: any) => {
      if (add) {
        if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
          setTimeout(() => {
            this.getWishList()
          }, 500);
        }
      }
    })
  }

  @HostListener('document:click', ['$event'])
  DocumentClick(event: any) {
    if (event && event.target && event.target.id != 'searchInputIn' && event.target.id != 'searchbar-content' && event.target.id != 'searchbar-product' && event.target.id != 'searchbar-category' && event.target.id != 'searchbar-skinType' && event.target.id != 'searchbar-skinConcern' && event.target.id != 'searchbar-brand') {
      this.restrictPopup();
    }

    if ($(event.target).closest("#brand-hover-id").length === 0) {
      this.brandClickActive = false;
      document.body.style.cssText = 'overflow: auto'
    }

    if (event && event.target && event.target.id != 'dropdownMenuButton1') {
      $('#toggleProfileMenu').hide()
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkScreenSize();
  }

  checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 991;
  }
  ngOnInit() {
    this.checkScreenSize()
    $(".hamburger-menu").toggleClass('active');
    this.userData = JSON.parse("" + SharedPrefrences.getUserData());
    if (this.userData) {
      if (this.userData.profile_pic != null && this.userData.profile_pic != '') {
        this.profileImage = this.userData.profile_pic;
      }
    }
    this.userId = SharedPrefrences.getUserId();
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.getAllCartProducts();
    }
    this.getAllBrand();
    if(this.isMobile){
      this.getCustomerMenuList();
    }
    document.body.addEventListener('click', this.toggleMobileSearchAndMenu.bind(this));
  }


  /**
     * Hide Share Box on outside click
     * @param event 
     */
  toggleMobileSearchAndMenu(event: Event): void {
    const isSearchBlog = (event.target as HTMLElement).closest('.search-icon-mobile') || (event.target as HTMLElement).closest('.searchbar');
    if (!isSearchBlog) {
      if (this.mobileSearchShow == true) {
        $(".searchbar").slideToggle();
        this.mobileSearchShow = !this.mobileSearchShow;
      }
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > this.lastScrollTop) {
      // Scrolling down
      this.renderer.addClass(this.el.nativeElement, 'highlight');
    } else {
      // Scrolling up
      this.renderer.removeClass(this.el.nativeElement, 'highlight');
    }
    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    if (this.lastScrollTop > 0) {
      $('.brand-hover').addClass('new-site-header')
    }
    else {
      $('.brand-hover').removeClass('new-site-header')
    }
  }

  /**
   * Date: 10-06-23
   * Method : This method is used to get all cart items 
   */
  async getAllCartProducts() {
    const getAllCart = this.wsShopAllService.getCartList("" + SharedPrefrences.getUserId())
    await lastValueFrom(getAllCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModuleResponse.data = response.data;
        this.filterArray();
        this._commonBehaviorChangeService.getCartList(this.mAddUpdateCartModuleResponse)
        await this.calculateTotal()
        await this.calculateTotalAmount();
        if(this.discountId){
          this.applyDiscount(this.discountCode)
        }
        this.getWishList();
      }
    })
  }

  /**
* Date:- 21-06-2023
* Method :- This method is used to Get Order Detail List
* @param userId :-  This param is used for request to Get Order Detail List
*/
  async getWishList() {
    const wishList = this.wsUserProfileService.getWishList("" + SharedPrefrences.getUserId())
    await lastValueFrom(wishList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mWishlistData = response.data
        this._commonBehaviorChangeService.getWishList(this.mWishlistData)
        this.filterArray()

        await this.mWishlistData && this.mWishlistData.length > 0 && this.mWishlistData.forEach((product: any) => {
          const cartPresent = this.mAddUpdateCartModuleResponse.data.filter(function (el: any) { return (el.productdetail.id === product['productdetail'].id && el.qty > 0) });
          if (cartPresent.length > 0) {
            product['productdetail'].cartQty = cartPresent[0].qty;
          }
        })
        
        await this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0 && this.mAddUpdateCartModuleResponse.data.forEach((cartItem: any) => {
          if (this.mWishlistData && this.mWishlistData.length > 0) {
            const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === cartItem.productdetail.id && cartItem.qty > 0) });
            if (present) {
              cartItem.like = true;
            } else {
              cartItem.like = false;
            }
          }
        })
        this.wishlistData = this.mWishlistData.filter((product:any) => !product['productdetail'].cartQty || product['productdetail'].cartQty < 1)
      }
    })
  }
  filterArray() {
    this.wishlist = this.mWishlistData.filter((wishlist:any) => !this.mAddUpdateCartModuleResponse.data.some((cart:any) => wishlist.productdetail.id === cart.productdetail.id));
  }

  changeCartItem(e: any, product: any) {
    this.mAddUpdateCartModule.qty = e.target.value;
    this.addtoCart(product)
  }

  addCartItem(product: any, i: any) {
    this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[i].qty + 1;
    this.addtoCart(product, 'add');
  }

  removeCartItem(product: any, i: any) {
    this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[i].qty - 1;
    this.addtoCart(product, 'remove')
  }

  deleteCartItem(product: any, i: any) {
    this.mAddUpdateCartModule.qty = 0;
    this.addtoCart(product, 'delete');
  }

  /**
   * Add and Remove Wishlist
   * @param wishlist
   * @param addRemove 
   */

  async addRemoveWishlist(product: any, val: any) {
    this.type = val;
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.addToWhislist(product, this.type)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.addToWhislist(product, this.type)
        }
      })
    }
  }


  async addToWhislist(product: any, productType?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.product_id = product.productdetail.id;
    this.mAddUpdateCartModule.iswishlistitem = true;
    if (productType == 'wishList') {
      const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.productdetail.id })
      if (wishlist > -1) {
        this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
      } else {
        delete this.mAddUpdateCartModule.id
      }
      this.mAddUpdateCartModule.qty = 0;
    } else {
      this.mAddUpdateCartModule.iswishlistitem = product.like ? false : true;
      if (product.like) {
        const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.productdetail.id })
        if (wishlist > -1) {
          this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
        }
      }
    }
    this.mAddUpdateCartModule.qty = product.like ? 0 : 1;
    var productIndex = this.mAddUpdateCartModuleResponse.data.findIndex((cartItem: any) => cartItem.product_id == product.product_id)
    if (this.mAddUpdateCartModule.qty > 0) {
      this.mAddUpdateCartModuleResponse.data[productIndex].like = true;
    } else {
      this.mAddUpdateCartModuleResponse.data[productIndex].like = false;
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this._commonBehaviorChangeService.addWishlist(true)
      } else {
        console.log("something went wrong")
      }
    })
  }

  async addtoCart(product: any, addRemove?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    this.mAddUpdateCartModule.iswishlistitem = false;
    this.mAddUpdateCartModule.product_id = product.id;
    const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
    if (cart > -1) {
      product.isLoading = true;
      this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
    } else {
    }
    const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
    await lastValueFrom(addRemoveProductFromCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.getAllCartProducts();
        if (addRemove && addRemove == 'add') {
          this._commonBehaviorChangeService.getToast('Product added to cart successfully');
        }
        if (addRemove && addRemove == 'remove') {
          this._commonBehaviorChangeService.getToast('Product removed from cart successfully');
        }
        if (addRemove && addRemove == 'delete') {
          this._commonBehaviorChangeService.getToast('Product removed from cart successfully');
        }
        product.isLoading = false;
      } else {
        console.log("something went wrong")
        product.isLoading = false;
      }
    })
  }

  async calculateTotal() {
    this.subTotalAmount = 0;
    this.totalItems = 0;
    this.mCheckoutRequest.productorderdetails = []
    if(this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0){
      this.mCheckoutRequest.warehouse_id = this.mAddUpdateCartModuleResponse.data[0].productdetail.warehouse_id
    await this.mAddUpdateCartModuleResponse.data.forEach((cartItem: any) => {
      this.productIds.push(cartItem.product_id)
      this.brandIds.push(cartItem.productdetail.brand_id)
      this.categoryIds.push(cartItem.productdetail.category_id)
      this.ProductIds = this.productIds.length < 2 ? this.productIds[0] : this.productIds.join(',')
      this.BrandIds = this.brandIds.length < 2 ? this.brandIds[0] :  this.brandIds.join(',')
      this.CategoryIds = this.categoryIds.length < 2 ? this.categoryIds[0] : this.categoryIds.join(',')
      this.getAllDiscount()
      this.mCheckoutRequest.productorderdetails.push({
        "product_id": cartItem.product_id ? cartItem.product_id : cartItem.productdetail.id,
        "qty": cartItem.qty,
        "product_price": cartItem.productdetail.your_price,
        "hsn": cartItem.productdetail.hsn,
        "tax": 0,
      })
      if (this.mWishlistData && this.mWishlistData.length > 0) {
        const present = this.mWishlistData.some(function (el: any) { return (el.productdetail.id === cartItem.productdetail.id && cartItem.qty > 0) });
        if (present) {
          cartItem.like = true;
        }
      }
      this.totalItems = this.totalItems + cartItem.qty;
      if (this.subTotalAmount == 0) {
        this.subTotalAmount = (parseInt(cartItem.productdetail.your_price) * parseInt(cartItem.qty))
      } else {
        this.subTotalAmount = this.subTotalAmount + (parseInt(cartItem.productdetail.your_price) * parseInt(cartItem.qty))
      }
    })
    } 
    else{
      this.removeDiscount();
    }
  }

  calculateIndividualTotal(qty: any, price: any) {
    return qty *  price;
  }

  async calculateTax() {
    this.taxableAmount = 0;
    this.productIds = [];
    this.brandIds = []
    this.categoryIds = []
    await this.mAddUpdateCartModuleResponse.data.forEach((product: any) => {
      this.productIds.push(product.product_id)
      this.brandIds.push(product.productdetail.brand_id)
      this.categoryIds.push(product.productdetail.category_id)

      if (product && product.productdetail && product.productdetail.taxes.length > 0) {
        this.taxableAmountCalculate = this.taxableAmountCalculate + ((product.productdetail.your_price * product.qty) * (product.productdetail.taxes[0].tax / 100));
        this.taxableAmount = this.taxableAmount + ((product.productdetail.your_price * product.qty) * product.productdetail.taxes[0].tax / 100);
      }
    })
    this.taxableAmount = parseFloat(this.taxableAmount).toFixed(2)
    this.ProductIds = this.productIds.length < 2 ? this.productIds[0] : this.productIds.join(',')
    this.BrandIds = this.brandIds.length < 2 ? this.brandIds[0] :  this.brandIds.join(',')
    this.CategoryIds = this.categoryIds.length < 2 ? this.categoryIds[0] : this.categoryIds.join(',')
    this.getAllDiscount()
  }

  calculateIndividualProductTax(amount: any, taxes: any, from?: any) {
    var taxAmount = 0;
    if (taxes && taxes.tax) {
      taxAmount = (amount * taxes.tax) / 100;
    }
    if (taxAmount == 0) {
      if (from) {
        return 0
      } else {
        return null
      }
    } else {
      if (from) {
        return taxAmount
      } else {
        return '₹' + taxAmount
      }
    }
  }

  calculateTotalAmount() {
    this.totalAmountWithoutDiscount = (this.subTotalAmount);
    this.totalAmountForShipping = this.totalAmountWithoutDiscount;
    if(this.totalAmountWithoutDiscount < 499){
      this.shippingCharge = 70;
    }else{
      this.shippingCharge = 0;
    }
    this.totalAmountWithoutDiscount = this.totalAmountWithoutDiscount + this.shippingCharge;
    this.totalAmountWithoutDiscount = parseFloat(this.totalAmountWithoutDiscount).toFixed(2);
    if (this.subTotalAmount < 499) {
      this.cartAmount = 499 - this.subTotalAmount;
    }
    if (this.showDiscountOnTotal) {
      if (this.discount.amount < 1) {
        this.discountApplied = this.totalAmountWithoutDiscount * this.discount.percentage / 100;
        if (this.discountApplied > this.totalAmountWithoutDiscount) {
          this.discountApplied = this.totalAmountWithoutDiscount;
        }
        if (this.discountApplied > this.discount.max_amount && this.discount.max_amount > 0) {
          if (this.discount.max_amount > this.totalAmountWithoutDiscount) {
            this.discountApplied = this.totalAmountWithoutDiscount;
          } else {
            this.discountApplied = this.discount.max_amount;
          }
        }
        this.totalAmount = this.totalAmountWithoutDiscount - this.discountApplied;
      }
      if (this.discount.amount > 0) {
        if (this.totalAmountWithoutDiscount > this.discount.amount) {
          this.discountApplied = this.discount.amount;
        } else {
          this.discountApplied = this.totalAmountWithoutDiscount
        }
        this.totalAmount = this.totalAmountWithoutDiscount - this.discountApplied;
      }
      this.discountAmount = this.discountApplied;
      return  parseFloat(this.totalAmount).toFixed(2);
    } else {
      this.totalAmount = (this.subTotalAmount) - this.discountAmount + (this.shippingCharge);
      return  parseFloat(this.totalAmount).toFixed(2);
    }
  }

  async getAllDiscount() {
    const getAllDiscount = this.wsCheckoutService.getAllDiscountByProductIds(this.ProductIds, this.BrandIds, this.CategoryIds)
    await lastValueFrom(getAllDiscount).then(async response => {
      if (response && response.statusCode == 200) {
        this.discountList = []
        await response['data'].forEach(async (discount: any) => {
          if (discount && discount.discounts.length > 0) {
            await discount.discounts.forEach((d: any) => {
              if (this.discountList.length < 1) {
                this.discountList.push(d)
              } else {
                var haveDiscount = this.discountList.findIndex((discountcheck: any) => discountcheck.id == d.id)
                if (haveDiscount == -1) {
                  this.discountList.push(d)
                }
              }
            })
          }
        })
      }
    });
  }

  backOfferClick() {
    if (this.boolOffer == true) {
      this.mobileAddress = false;
      this.cartAddress = true;
      this.mobilePaymentClick = false;
      this.mobileOfferClick = false;
      const m_stepper_detail = document.querySelectorAll('.m-stepper-detail');
      m_stepper_detail.forEach(element => {
        element.classList.remove('hide');
      })

      const row = document.querySelectorAll('.row');
      row.forEach(element => {
        element.classList.remove('hide');
      })
      $('#collapseOne').collapse('show');
    }
    else {
      this.mobileOfferClick = false;
      this.mobileAddress = false;
      this.cartAddress = false;
      this.mobilePaymentClick = true;
      const m_stepper_detail = document.querySelectorAll('.m-stepper-detail');
      m_stepper_detail.forEach(element => {
        element.classList.remove('hide');
      })

      const row = document.querySelectorAll('.row');
      row.forEach(element => {
        element.classList.remove('hide');
      })
      $('#collapseThree').collapse('show');
    }
  }

  offerClick(bool?: boolean) {
   
    const m_stepper_detail = document.querySelectorAll('.m-stepper-detail');
    m_stepper_detail.forEach(element => {
      element.classList.add('hide');
    })

    if (bool) {
      this.boolOffer = bool;
    }
    else {
      this.boolOffer = false;
    }
    const row = document.querySelectorAll('.row');
    row.forEach(element => {
      element.classList.add('hide');
    })
    this.mobileOfferClick = true;
    setTimeout(() => {
      this.scrollToViewOffers()
  }, 200);
  }

  scrollToViewOffers() {
    
    let element: any = document.getElementById("offersView1")
    const yOffset = -100;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });

  }

  clickOffers(offer: any) {
   
    if (offer == 'on') {
      this.offers = true;
    }
    if (offer == 'off') {
      this.offers = false
    }
  }

  async applyDiscount(discountCode?: any) {
    
    if (this.discountId) {
      this.removeDiscount()
    }
    if (discountCode) {
    }
    if (discountCode != '') {
      const getDiscount = this.wsCheckoutService.getDiscount(discountCode)
      await lastValueFrom(getDiscount).then(async response => {
        if (response && response.statusCode == 200) {
          if (response.data.length < 1) {
            this.toast.error("Please enter valid discount code.")
            return;
          }
          
          this.discount = response.data[0];

          if (this.subTotalAmount < this.discount.minimum_cart_amount) {
            this.toast.error("Discount code is only applicable if your subTotal is more than " + this.discount.minimum_cart_amount)
            return;
          }

          if (this.discount.on_cart_value || this.discount.apply_discount_on_cart_value) {
            this.showDiscountOnTotal = true;
            this.discountCode = discountCode;
            this.discountId = this.discount.id;
          } else {
            if (this.discount.is_all) {
              if (this.discount.type == 'product') {
                this.discountCode = discountCode;
                await this.mAddUpdateCartModuleResponse.data.forEach((product: any, i: any) => {
                  this.discountCalculate((product['productdetail'].your_price * product['qty']), i)
                })
              } else if (this.discount.type == 'brand') {
                this.discountCode = discountCode;
                await this.mAddUpdateCartModuleResponse.data.forEach((product: any, i: any) => {
                  this.discountCalculate((product['productdetail'].your_price * product['qty']), i)
                })
              } else if (this.discount.type == 'category') {
                this.discountCode = discountCode;
                await this.mAddUpdateCartModuleResponse.data.forEach((product: any, i: any) => {
                  this.discountCalculate((product['productdetail'].your_price * product['qty']), i)
                })
              }
              this.discountId = this.discount.id;
              if (this.discountAmount == 0) {
                this.toast.error("Discount Code is not applicable for your selected products")
              }
            } else {
              if (this.discount.type == 'product') {
                this.discountCode = discountCode;
                await this.productIds.forEach((id: any, i: any) => {
                  if (this.discount.product_id_Array.includes(id)) {
                    this.discountCalculate((this.mAddUpdateCartModuleResponse.data[i]['productdetail'].your_price * this.mAddUpdateCartModuleResponse.data[i]['qty']), i)
                  }
                })
              } else if (this.discount.type == 'brand') {
                this.discountCode = discountCode;
                await this.brandIds.forEach((id: any, i: any) => {
                  if (this.discount.brand_id_Array.includes(id)) {
                    this.discountCalculate((this.mAddUpdateCartModuleResponse.data[i]['productdetail'].your_price * this.mAddUpdateCartModuleResponse.data[i]['qty']), i)
                  }
                })
              } else if (this.discount.type == 'category') {
                this.discountCode = discountCode;
                await this.categoryIds.forEach((id: any, i: any) => {
                  if (this.discount.category_id_Array.includes(id)) {
                    this.discountCalculate((this.mAddUpdateCartModuleResponse.data[i]['productdetail'].your_price * this.mAddUpdateCartModuleResponse.data[i]['qty']), i)
                  }
                })
              }
              this.discountId = this.discount.id;
              if (this.discountAmount == 0) {
                this.toast.error("Discount Code is not applicable for your selected products")
              }
            }
          }
        }
      });
    } else {
      this.toast.error("Please enter Discount Code")
    }
  }

  removeDiscount() {
    this.discountAmount = null;
    this.discountCode = '';
    this.discountId = null;
    this.showDiscountOnTotal = false;
    if(this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.length > 0){
      this.mAddUpdateCartModuleResponse.data.forEach((product: any) => {
        if (product.discountApplied) {
          delete product.discountApplied;
          delete product.discountAppliedAmount;
          delete product.discountType;
        }
      })
    }
  }

  discountCalculate(your_price: any, i: any) {
    if (this.discount.amount < 1) {
      this.discountApplied = your_price * this.discount.percentage / 100;
      if (this.discountApplied > your_price) {
        this.discountApplied = your_price;
      }
      if (this.discountApplied > this.discount.max_amount && this.discount.max_amount > 0) {
        if (this.discount.max_amount > your_price) {
          this.discountApplied = your_price;
        } else {
          this.discountApplied = this.discount.max_amount;
        }
      }
      this.mAddUpdateCartModuleResponse.data[i]['discountApplied'] = this.discountApplied;
      this.mAddUpdateCartModuleResponse.data[i]['discountAppliedAmount'] = your_price - this.discountApplied;
      this.mAddUpdateCartModuleResponse.data[i]['discountType'] = 'percentage';
      this.discountAmount = this.discountAmount + this.discountApplied;
      return this.discountApplied;
    }
    if (this.discount.amount > 0) {
      if (your_price > this.discount.amount) {
        this.discountApplied = this.discount.amount;
      } else {
        this.discountApplied = your_price
      }
      this.mAddUpdateCartModuleResponse.data[i]['discountApplied'] = this.discountApplied;
      this.mAddUpdateCartModuleResponse.data[i]['discountAppliedAmount'] = your_price - this.discountApplied;
      this.mAddUpdateCartModuleResponse.data[i]['discountType'] = 'fix';
      this.discountAmount = this.discountAmount + this.discountApplied;
      return this.discountApplied;
    }

    this.discountApplied = 0
    this.mAddUpdateCartModuleResponse.data[i]['discountApplied'] = this.discountApplied;
    this.mAddUpdateCartModuleResponse.data[i]['discountAppliedAmount'] = your_price - this.discountApplied;
    this.discountAmount = this.discountAmount + this.discountApplied;
    this.viewOffers = false;

    return this.discountApplied;
  }


  profileClick(val?: any) {
    this.userId = SharedPrefrences.getUserId();
    if (this.userId == '' || this.userId == null) {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.userId = SharedPrefrences.getUserId();
          if (val == 'true') {
            this.openUserProfile();
          }
          else {
            if (val) {

              this.openUserProfile();
            } else {
              window.location.reload()
            }
          }
        }else{
          window.location.reload()
        }
      })
    } else {
      $('#toggleProfileMenu').toggle()
      if (val == 'true') {
        this.openUserProfile()
      }
      else {
        if (val) {
          this.openUserProfile()
        }
      }
    }
    this.closeMobileMenu();
  }
  openUserProfile() {
    this.userId = SharedPrefrences.getUserId();
    if (this.isMobile) {
      this.router.navigate(['/user-your-profile']);
    } else {

      this.router.navigate(['user/' + this.userId])
    }
  }
  showUserProfile() {
    this.userId = SharedPrefrences.getUserId();
    if (this.userId == '' || this.userId == null) {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.userId = SharedPrefrences.getUserId();
          this.router.navigate(['user/' + this.userId])
        }
      })
    } else {
      this.router.navigate(['user/' + this.userId])
    }
  }
  logout() {
    SharedPrefrences.clearAllPrefrences()
    this.router.navigate(['home-page/']).then(() => {
      window.location.reload()
    })
  }

  goToOrders() {
    localStorage.setItem('orderType', 'order');
    this.router.navigate(['/user-my-orders']);
    this.closeMobileMenu()
  }

  goToBrands() {
    this.closeMobileMenu()

    this.router.navigate(["/brands-directory"])
  }
  goToProductList() {
    this.userId = SharedPrefrences.getUserId();
    if (this.userId == '' || this.userId == null) {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
    }
    else{
      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      }
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(["/product-list/wishlist"])
    }
  }

  checkoutOrder() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if (mobile) {
      if(this.discountId){
        this.router.navigate(["/checkout-new-mob/cart/" + this.discountCode])
      }else{
        this.router.navigate(["/checkout-new-mob/cart"])
      }
    } else {
      if(this.discountId){
        this.router.navigate(["/checkout-new/cart/" + this.discountCode])
      }else{
        this.router.navigate(["/checkout-new/cart"])
      }
    }
  }

  closeMobileMenu() {
    var enumenu_ul: any = document.getElementsByClassName('enumenu_ul')
    if ($('.enumenu_ul').hasClass('mob')) {
      if (enumenu_ul) {
        enumenu_ul[0].style.display = 'none'
      }
      $(".menu-icon").removeClass("active");
      document.body.classList.remove('menu-open')
    }
  }

  slideToggleButton() {
    $(".hamburger-menu").toggleClass('active');
  }

  onFocusEvent(val: any) {
    if (this.text.length == 0 && val) {
      this.show = false
      this.showNoData = false
      this.showOldData = true
      this.getSearchHistory();

    } else {
      this.show = false
      this.showNoData = false
      this.showOldData = false
    }
  }

  selectText(val: any) {
    this.text = val.trim();
    this.getCustomer('mouse')
  }

  getSearchHistory() {
    this.searchHistory = localStorage.getItem(this.storageKey);
    if (this.searchHistory != 'undefined' && this.searchHistory != null) {
      this.arrSearchHistory = JSON.parse(this.searchHistory)
    }
    return this.arrSearchHistory;
  }

  async getCustomer(mouse?: any) {
    if (this.text.length > 0) {
      this.show = true
      this.showOldData = false
      this.getCustomerData(this.text)

    }
    if (this.text.length > 0 && mouse == 'mouse') {
      this.getCustomerData(this.text, true)
    }
    else if (this.text.length > 0 && mouse != 'mouse') {
      this.show = true
      this.showOldData = false
      this.getCustomerData(this.text)

    }
    else if (this.text.length == 0) {
      this.show = false
      this.showNoData = false
      this.showOldData = false
    }
    else {
      this.show = false
      this.showNoData = false
      this.showOldData = false
    }
  }

  async getCustomerData(val: any, newVal?: any) {
    const getCustomer = this.wsLandingService.getCustomerProducts(val)
    await lastValueFrom(getCustomer).then(async response => {
      if (response && response.statusCode == 200) {
        this.customerData = response.data;
        this.productList = this.customerData.productList;
        this.brandList = this.customerData.brandList;
        this.categoryList = this.customerData.categoryList;
        this.skinConcernsList = this.customerData.skinConcernsList;
        this.skinTypeList = this.customerData.skinTypeList;

        if (this.productList.length <= 0 && this.brandList.length <= 0 && this.categoryList.length <= 0 && this.skinConcernsList.length <= 0 && this.skinTypeList.length <= 0) {
          this.showNoData = true;
          this.show = false;
        } else {
          this.showNoData = false;

          if (newVal == true) {

            if (this.productList.length > 0) {
              let productName = this.productList.filter((item: any) => item.name == val);
              if (productName.length > 0) {
                this.showProduct(productName[0]);
              }
            }

            if (this.brandList.length > 0) {
              let brandName = this.brandList.filter((item: any) => item.name == val);
              if (brandName.length > 0) {
                this.viewBrandDetail(brandName[0]);
              }
            }

            if (this.categoryList.length > 0) {
              let categoryName = this.categoryList.filter((item: any) => item.subCategory_name == val);
              if (categoryName.length > 0) {
                this.goToShopAll(categoryName[0].subCategory_name, categoryName[0].category_id, categoryName[0].subCategory_id);
              }
            }

            if (this.skinConcernsList.length > 0) {
              let concernName = this.skinConcernsList.filter((item: any) => item.name == val);
              if (concernName.length > 0) {
                this.goToShopAllWithSkinConcern(concernName[0].name, concernName[0].category_id, concernName[0].id);
              }
            }

            if (this.skinTypeList.length > 0) {
              let typeName = this.skinTypeList.filter((item: any) => item.name == val);
              if (typeName.length > 0) {
                this.goToShopAllWithSkinType(typeName[0].name, typeName[0].category_id, typeName[0].id);
              }
            }
          }
        }
      } else {
      }
    })
  }

  closeSearchBar() {
    this.show = false
    this.showNoData = false
    this.text = ''
  }

  showProduct(product: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.searchHistory = this.getSearchHistory();
    let newSearch = this.searchHistory.filter((item: any) => item == product.name)
    if (newSearch == null || newSearch.length == 0) {
      this.searchHistory.unshift(product.name);
      if (product.name.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    else {
      this.searchHistory = this.searchHistory.filter((item: any) => item != product.name);
      this.searchHistory.unshift(product.name);
      if (product.name.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }

    this.router.onSameUrlNavigation = 'reload';
    this.restrictPopup();
    this.closeSearchBar();
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')])
  }

  viewBrandDetail(brand: MBrandListModal, image?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.searchHistory = this.getSearchHistory();
    let newSearch = this.searchHistory.filter((item: any) => item == brand.name);
    if (newSearch == null || newSearch.length == 0) {
      this.searchHistory.unshift(brand.name);
      if (brand.name.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    else {
      this.searchHistory = this.searchHistory.filter((item: any) => item != brand.name);
      this.searchHistory.unshift(brand.name);
      if (brand.name.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }

    this.router.onSameUrlNavigation = 'reload';
    this.restrictPopup();
    this.closeSearchBar();
    this.closeMobileMenu();
    this.brandClickActive = false;
    var brandId = brand.id;
    this.router.navigate(["/individual-brand/" + brand.name.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')], {
      queryParams: {
        b: brandId
      }
    })
  }

  goToShopAll(val: any, catId: any, subId?: any, leafLevelId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.searchHistory = this.getSearchHistory();
    let newSearch = this.searchHistory.filter((item: any) => item == val);
    if (newSearch == null || newSearch.length == 0) {
      this.searchHistory.unshift(val);
      if (val.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    else {
      this.searchHistory = this.searchHistory.filter((item: any) => item != val);
      this.searchHistory.unshift(val);
      if (val.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }

    this.router.onSameUrlNavigation = 'reload';
    this.restrictPopup();
    this.closeSearchBar();
    this.closeMobileMenu();
    this.router.navigate(["/shop-all"], {
      queryParams: {
        c: catId,
        sub: subId,
        l3: leafLevelId
      }
    })
  }
  goToShopAllWithoutFilters() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.restrictPopup();
    this.closeSearchBar();
    this.closeMobileMenu();
    this.router.navigate(["/shop-all"])
  }


  goToShopAllWithSkinConcern(val: any, catId: any, skinConcernId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.searchHistory = this.getSearchHistory();
    let newSearch = this.searchHistory.filter((item: any) => item == val);
    if (newSearch == null || newSearch.length == 0) {
      this.searchHistory.unshift(val);
      if (val.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    else {
      this.searchHistory = this.searchHistory.filter((item: any) => item != val);
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }

    this.router.onSameUrlNavigation = 'reload';
    this.restrictPopup();
    this.closeSearchBar();
    this.closeMobileMenu();
    this.router.navigate(["/shop-all"], {
      queryParams: {
        sc: skinConcernId
      }
    })
  }
  goToShopAllWithSkinType(val: any, catId: any, skinTypeId?: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.searchHistory = this.getSearchHistory();
    let newSearch = this.searchHistory.filter((item: any) => item == val);
    if (newSearch == null || newSearch.length == 0) {
      this.searchHistory.unshift(val);
      if (val.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }
    else {
      this.searchHistory = this.searchHistory.filter((item: any) => item != val);
      this.searchHistory.unshift(val);
      if (val.title.length > 0) {
        localStorage.setItem(this.storageKey, JSON.stringify(this.searchHistory));
      }
    }

    this.router.onSameUrlNavigation = 'reload';
    this.restrictPopup();
    this.closeSearchBar();
    this.closeMobileMenu();
    this.router.navigate(["/shop-all"], {
      queryParams: {
        st: skinTypeId
      }
    })
  }

  restrictPopup() {
    $('.searchbar-content').hide();
  }

  brandClick() {
    this.brandClickActive = !this.brandClickActive
  }

  brandHover() {
    this.brandClickActive = true;
    document.body.style.cssText = 'overflow-y: hidden'
  }

  brandNotHover() {
    this.brandClickActive = false;
    document.body.style.cssText = ''
  }

  /**
   * Date: 10-06-23
   * Method : This method is used to get all brand 
   */
  async getAllBrand() {
    this.mCommonListModalRequest.take = 1000
    this.mCommonListModalRequest.isAllowInactive = false;
    const getAllBrand = this.wsShopAllService.getAllBrand(this.mCommonListModalRequest)
    await lastValueFrom(getAllBrand).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetBrandResponse.data = response.data.sort(function (a: any, b: any) {
          if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) {
            return -1;
          } else {
            return 0
          }
        });
        this.mGetBrandResponse.data.forEach((brand: any) => {
          this.alphabet.forEach(alpha => {
            let brandname = brand.name.toLowerCase();
            let alphaSmall = alpha.toLowerCase()
            if (brandname.startsWith(alphaSmall)) {
              if (this.alphabets.length < 1) {
                this.alphabets.push(alpha);
              } else {
                if (this.alphabets.indexOf(alpha) == -1) {
                  this.alphabets = [...this.alphabets, ...alpha]
                }
              }
            }
          })
          if (brand.imageList && brand.imageList.length > 0) {
            brand.imageList.forEach((b_image: any) => {
              b_image['name'] = brand.name
              b_image['brand_type'] = brand.brand_type;
              b_image['id'] = brand.id;
              if (b_image.type == 'brand_logo_image' && !this.alreadyProcessedIds.has(brand.id)) {
                b_image['logo_image'] = b_image.path;
                this.brandImageList.push(b_image);
                this.alreadyProcessedIds.add(brand.id);
              }
            })
          }
        })
      } else {
      }
    })
  }

  scrollToAlphaView(val: any) {
    var alphaSelected = document.getElementById(val)
    if (alphaSelected) {
      alphaSelected.scrollIntoView()
    }
  }

  searchBrand(e: any) {
    if (e.target.value.length < 1) {
      this.mCommonListModalRequest.search = ""
      this.mGetBrandResponse.data = [];
      this.alphabets = [];
      this.getAllBrand();
    } else if (e.target.value.length > 2) {
      this.mGetBrandResponse.data = [];
      this.alphabets = [];
      this.mCommonListModalRequest.search = "name Like '%" + e.target.value + "%'";
      this.getAllBrand();
    }
  }

  async getCustomerMenuList() {
        await this.customerMenuLists.forEach(async (category: any, i: any) => {
          await this.getAllModuleDataOfShopAll(category.id, i)
        })
  }


  /**
   * Date: 10-06-23
   * Method: This method is used to get subcategory , skintype and skin concern of selected category
   */
  async getAllModuleDataOfShopAll(categoryId: any, i: any) {
    const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAll("" + categoryId)
    await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
      if (response && response.statusCode == 200) {
        this.mGetAllShopAllModuleDataResponse.data = response.data;
        this.customerMenuLists[i]['skinConcernList'] = this.mGetAllShopAllModuleDataResponse.data.skinConcernList;
        this.customerMenuLists[i]['skinTypeList'] = this.mGetAllShopAllModuleDataResponse.data.skinTypeList;
      } else {
      }
    })
  }

  offer() {
    $('.enumenu_ul').hide();
    $('.menu-icon').toggleClass('active')
    this.router.navigate(['offers'])
  }
  needHelp() {
    $('.enumenu_ul').hide();
    $('.menu-icon').toggleClass('active')
    const data = {data: true};
    this.router.navigate(['need-help'], {state: data})
  }

  mobileserch() {
    $(".searchbar").slideToggle();
    this.mobileSearchShow = !this.mobileSearchShow;
  }
}

